import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect, useContext } from 'react';
import { ApiContext } from '../modules/api';
import useApp from './useApp';
export default (function (_ref) {
  var initialRequest = _ref.initialRequest,
      disableAppLoader = _ref.disableAppLoader,
      disableAppError = _ref.disableAppError,
      disableCache = _ref.disableCache,
      onSuccess = _ref.onSuccess,
      onError = _ref.onError,
      onFinish = _ref.onFinish;
  var api = useContext(ApiContext);
  var app = useApp();

  var _useState = useState(initialRequest),
      _useState2 = _slicedToArray(_useState, 2),
      request = _useState2[0],
      setRequest = _useState2[1];

  var _useState3 = useState(!disableCache && initialRequest && initialRequest.path ? api.getCache(initialRequest.path) : undefined),
      _useState4 = _slicedToArray(_useState3, 2),
      response = _useState4[0],
      setResponse = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      loading = _useState6[0],
      setLoading = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2),
      error = _useState8[0],
      setError = _useState8[1];

  var reset = function reset() {
    setError();
    setLoading();
    setRequest();
    setResponse();
  };

  useEffect(function () {
    if (!request || !request.path) {
      return;
    }

    var _request$apiName = request.apiName,
        apiName = _request$apiName === void 0 ? 'default' : _request$apiName,
        _request$method = request.method,
        method = _request$method === void 0 ? 'get' : _request$method,
        path = request.path,
        init = request.init;
    var subscribed = true;
    !disableAppLoader && app.setLoading(true);
    setLoading(true);
    setError();
    api[method.toLowerCase()](apiName, path, init).then(function (response) {
      subscribed && setResponse(response);
      !disableCache && api.setCache(path, response);
      onSuccess && onSuccess(response);
    })["catch"](function (error) {
      !disableAppError && app.setError({
        message: error.response && error.response.status === 400 && error.response.data && error.response.data.detail || error.message || error || 'Unknown error'
      });
      setError(error);
      onError && onError(error);
    })["finally"](function () {
      !disableAppLoader && app.setLoading(api.isLoading());
      setLoading(false);
      onFinish && onFinish();
    });
    return function () {
      subscribed = false;
    };
  }, [request]);
  return [response, setRequest, loading, error, reset];
});